const productInitiativesScroll = () => {
  if (!document.querySelector('[data-initiative-product]')) {return}
  const products = document.querySelectorAll('[data-initiative-product]')
  const bottom = document.querySelector('[data-product-initiatives-bottom]')
  const productsArray = [...products]
  
  const addProductsToPage = () => {
    //unhide 9 products when user see the loading spinner
    let i = 0
    while (i < 9) {
      if (productsArray.length <= 0) {
        bottom.classList.add('hide')
        return
      }
      productsArray[0].classList.remove('hide')
      productsArray.shift()
      i++
    }
  }

  //check if the loading spinner is displaying, if so grab more products
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        addProductsToPage()
      }
    })
  })
  observer.observe(bottom)

  //start with 9 products displaying
  addProductsToPage()
}

export default productInitiativesScroll